import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Home from './components/Home.vue'
import Inquiry from './components/Inquiry.vue'
import ExternalInquiry from './components/ExternalInquiry.vue'
import ownReports from './components/OwnReports.vue'
import ExternalReports from './components/ExternalReports.vue'
import Report from './components/Report.vue'
import Companies from './components/Companies.vue'
import Company from './components/Company.vue'
import Login from './components/Login.vue'
import Log from './components/Log.vue'
import Calendar from './components/Calendar.vue'
// import OtpuskConfirmation from './components/OtpuskConfirmation.vue'
import { getAccess } from './components/mixins/getAccess.js'
import tabsData from './data/tabsData.js'
// import Otpusks from './components/Otpusks.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/inquiry',
    name: 'inquiry',
    component: Inquiry,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/external-inquiry',
    name: 'ExternalInquiry',
    component: ExternalInquiry,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/reports/own',
    name: 'ownReports',
    component: ownReports,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/external-reports/:id',
    name: 'ExternalReports',
    component: ExternalReports,
    meta: {
      requiresNoAuth: true
    }
  },
  {
    path: '/reports/new',
    name: 'newReport',
    component: Report,
    meta: {
      requiresAccess: true
    }
  },
  {
    path: '/reports/edit/:id',
    name: 'editReport',
    component: Report,
    meta: {
      requiresAccess: true
    }
  },
  {
    path: '/companies',
    name: 'companies',
    component: Companies,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/companies/new',
    name: 'newCompany',
    component: Company,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/companies/:companyId',
    name: 'newProject',
    component: Companies,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/companies/:companyId/:projectId',
    name: 'getProject',
    component: Companies,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/companies/:companyId/:projectId/:objectId',
    name: 'newPart',
    component: Companies,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/companies/:companyId/:projectId/:objectId/:partId',
    name: 'getPart',
    component: Companies,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendar,
    meta: {
      requiresAccess: true
    }
  },
  // {
  //   path: '/otpusk/confirm/:id',
  //   name: 'otpuskConfirm',
  //   component: OtpuskConfirmation,
  //   meta: {
  //     requiresAuthAndSuperAdminOrAdmin: true
  //   }
  // },
  // {
  //   path: '/otpusk/reject/:id',
  //   name: 'otpuskReject',
  //   component: OtpuskConfirmation,
  //   meta: {
  //     requiresAuthAndSuperAdminOrAdmin: true
  //   }
  // },
  {
    path: '/users',
    name: 'usersView',
    component: () => import('./components/UsersView.vue'),
    meta: {
      requiresAccess: true,
    },
    children: [
      {
        path: 'users',
        name: 'users',
        component: () => import('./components/Users.vue'),
        meta: {
          requiresAccess: true,
        }
      },
      {
        path: 'roles',
        name: 'roles',
        component: () => import('./components/Roles.vue'),
        meta: {
          requiresAccess: true,
        }
      },
    ]
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: () => import('./components/Inventory.vue'),
    meta: {
      requiresAccess: true
    }
  },
  {
    path: '/deliveries',
    name: 'deliveries',
    component: () => import('./components/Deliveries.vue')
    // meta: {
    //   requiresAccess: true
    // }
  },
  {
    path: '/log',
    name: 'log',
    component: Log,
    meta: {
      requiresAccess: true,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('checkAuth').then(() => {
    if (to.matched.some(record => record.meta.requiresAccess)) {
      let companyRoutes = ['companies', 'newCompany', 'newProject', 'getProject', 'newPart', 'getPart']

      if (to.name === 'calendar') {
        if (getAccess([0, 2, 3, 4], 'calendar')) {
          next()
          return;
        }
      } else if (to.name === 'ExternalInquiry') {
        if (getAccess('external_inquiry', 'inquiry')) {
          next()
          return;
        }

      } else if (to.name === 'inquiry') {
        let hasAccesToInquiries = false
        let hasAccesToAtLeastOneTab = false

        if (getAccess(['full_inquiries', 'personal_inquiries'], 'inquiry')) {
          hasAccesToInquiries = true
        }

        for (const t of Object.keys(tabsData.inquiry.tabValues)) {
          if (!isNaN(t)) {
            if (getAccess(t, 'inquiry')) {
              hasAccesToAtLeastOneTab = true;
              break;
            }
          }
        }

        if (hasAccesToInquiries && hasAccesToAtLeastOneTab) {
          next()
          return;
        }

      } else if (to.name === 'log') {
        if (getAccess('log', 'log')) {
          next()
          return;
        }
      } else if (to.name === 'usersView' || to.name === 'users' || to.name === 'roles') {
        if (getAccess(['users_info', 'users_roles'], 'users')) {
          next()
          return;
        }
      } else if (companyRoutes.includes(to.name)) {
        if (getAccess('companies_projects', 'companies')) {
          next()
          return;
        }
      } else if (to.name === 'ownReports' || to.name === 'newReport' || to.name === 'editReport') {
        if (getAccess(['planning', 'reporting', 'self_reports', 'self_reports_groups', 'accept_self_reports', 'accept_own_project_reports'], 'reports')) {
          next()
          return;
        }
      } else if (to.name === 'inventory') {
        let hasAccess = false;

        for (const t of Object.keys(tabsData.inventory.tabValues)) {
          if (getAccess(t, 'inventory')) {
            hasAccess = true;
            break;
          }
        }

        if (hasAccess) {
          next()
          return;
        }
      } else if (to.name === 'deliveries') {
        if (getAccess(['personal', 'full'], 'delivery')) {
          next()
          return;
        }
      }

      if (Vue.prototype.$snotify) {
        Vue.prototype.$snotify.error('Нямате достъп до този раздел!');
      }

      // stay on same route
      next({
        path: from.fullPath
      })
    } else if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.isLoggedIn) {
        next()
        return;
      }
      const loginpath = window.location.pathname;
      next({
        path: '/login',
        query: {
          from: loginpath
        }
      });
    } else {
      next();
    }
  })
})

export default router